<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-header v-if="is_god">
                <i class="icon-menu mr-1"></i>Типы объектов размещения
            </b-card-header>
            <b-card-body>
                <v-server-table :url="apiurl('hotel/type/table')"  :columns="columns" :options="options" :theme="theme" id="hotelTypesTable" ref="hotelTypesTable" name="hotelTypesTable26">
                </v-server-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

    import Vue from 'vue'
    import VueJsonPretty from 'vue-json-pretty'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import {CONSTANTS} from '@/constants';
    import m_disabled from '../jsx/htypes/m_disabled'
    import medical from '../jsx/htypes/medical'

    Vue.use(ServerTable)

    export default {
        name: 'NsbTechHotelTypes',
        components: {
            ServerTable,
            Event,
            VueJsonPretty
        },
        mixins: [functions],
        data: function () {
            return {
                data:[],
                columns: ['id', 'title', 'medical', 'm_disabled'],
                dateColumns:[],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        title: 'наименование тпа объектов отдыха',
                        medical: function(h) { return (
                             <i class="fa fa-plus-square fa-lg" title="объект медицинского профиля"></i>
                        )},
                        m_disabled: function(h) { return (
                            <i class="fa fa-pause-circle-o fa-lg" title="отключенные типы объектов"></i>
                        )},
                    },
                    sortable: ['id', 'title'],
                    filterable: ['id', 'title'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 20   ,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    templates: { m_disabled, medical },
                    perPage:25,
                    perPageValues:[],
                    columnsClasses: {
                        medical: "center",
                        m_disabled: "center",
                    },
                },
                theme: 'bootstrap4',
                template: 'default',
            }
        },
        methods: {
            onEdit: function (id) {
                alert(id)
            },
        },
        created: function() {
        },
    };
</script>

<style lang="scss">

</style>
